<template>
  <!-- User Profile Product Access Info Tab Content View From Account Profile -->
    <div class="tabs-content-secondblock">
        <div class="row">
            <div class="col-lg-12">
                <div class="ml-2 mr-1 mb-3">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="infoHeader py-6 px-4">
                                <div class="d-flex justify-content-between align-items-center">
                                    <span class="fw-700 fs-15">
                                        Subscribed Products
                                        <sup class="fs-14 ml-1 mandatory">
                                            <el-tooltip class="item" effect="light" placement="right">
                                                <div slot="content">
                                                    Click on the respective subscribed product to check the access privileges in <span style="font-weight: 700">Access Mgmt</span> Page
                                                </div>
                                                <i class="icon-information text-secondary" style="font-size: 14px"></i>
                                            </el-tooltip>
                                        </sup>
                                    </span>
                                    <button v-if="!more && access.length > 6" class="btn btn-new-primary btn-smm d-flex align-items-center" @click="more = true">
                                        <i class="icon-chevron-double-down fs-18"></i> <span class="fs-12">View More</span>
                                    </button>
                                    <button v-else-if="more && access.length > 6" class="btn btn-new-primary btn-smm d-flex align-items-center" @click="more = false">
                                        <i class="icon-chevron-double-up fs-18"></i> <span class="fs-12">View Less</span>
                                    </button>
                                </div>
                                <div class="d-flex justify-content-center" v-if="ajaxCallinprogress">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#005dae" />
                                </div>
                                <div class="d-flex justify-content-center fs-14 fw-600" v-if="access.length == 0 && !ajaxCallinprogress">
                                    Products Not Found
                                </div>
                                <div class="d-flex flex-wrap" style="column-gap: 50px !important;">
                                    <div v-for="(prod,index) in access" :key="index">
                                        <div v-if="!more && index <= 7" class="d-flex flex-column align-items-center p-4 mt-8" style="box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.41); border-radius: 6px; height: 12em; width: 12em;">
                                            <img :src="prod.logo_blue" height="40px" />
                                            <el-tooltip class="item" effect="light" placement="right">
                                                <div slot="content">
                                                    {{ prod.product_name || "-" }}
                                                </div>
                                                <span class="fw-600 fs-14 text-center m-4" style="color: #0d5be6; line-height: 20px; height: 40px; white-space: nowrap; width: 95%; overflow: hidden; text-overflow: ellipsis">{{ prod.product_name || "-" }}</span>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="light" placement="right">
                                                <div slot="content">
                                                    {{ prod.access_level || "-" }}
                                                </div>
                                                <button type="button" class="product-role fw-600">{{ prod.access_level || "-" }}</button>
                                            </el-tooltip>
                                        </div>
                                        <div v-else-if="more" class="d-flex flex-column align-items-center p-4 mt-8" style="box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.41); border-radius: 6px; height: 12em; width: 12em;">
                                            <img :src="prod.logo_blue" height="40px" />
                                            <el-tooltip class="item" effect="light" placement="right">
                                                <div slot="content">
                                                    {{ prod.product_name || "-" }}
                                                </div>
                                                <span class="fw-600 fs-14 text-center m-4" style="color: #0d5be6; line-height: 20px; height: 40px; white-space: nowrap; width: 95%; overflow: hidden; text-overflow: ellipsis">{{ prod.product_name || "-" }}</span>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="light" placement="right">
                                                <div slot="content">
                                                    {{ prod.access_level || "-" }}
                                                </div>
                                                <button type="button" class="product-role fw-600">{{ prod.access_level || "-" }}</button>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HalfCircleSpinner } from "epic-spinners";
export default {
    props: ['employe_id', 'company_id'],
    components:{
        HalfCircleSpinner
    },
    data() {
        return {
            more: false,
            access: [],
            ajaxCallinprogress: false,
        }
    },
    methods: {
        async getProductAccess() {
            this.ajaxCallinprogress= true
            let params = {
                employee_id: this.employe_id,
                company_id: this.company_id
            };
            let res = await this.$http.post("/employees/get_products_employee", params);
            if (res.data.status_id == 1) {
                this.access = res.data.response.products_enabled;
            }
            this.ajaxCallinprogress= false
        }
    },
    mounted() {
        this.getProductAccess();
    },
}
</script>
<style scoped>
.product-role{
    background: green !important;
    color: white !important;
    font-weight: 500;
    line-height: 21px !important;
    height: 26px !important;
    width: 7em !important;
    border-radius: 5px !important;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/components/ProductAccessView.vue